<template>
  <svg
    width="1280"
    height="170"
    viewBox="0 0 1280 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="32" width="397.333" height="104" rx="16" fill="#111111" />
    <rect x="48" y="16" width="72" height="72" rx="12" fill="#1F1F1F" />
    <path
      d="M90.4132 52.0908L90.1482 52.0251C92.4122 52.5494 94.7413 51.304 95.3501 49.1992C95.4985 48.6925 95.5372 48.1637 95.464 47.6431C95.3909 47.1225 95.2073 46.6204 94.9238 46.1657C94.6404 45.7111 94.2627 45.3128 93.8124 44.9938C93.3621 44.6748 92.8482 44.4414 92.3002 44.307L90.3875 43.8323L91.5242 39.9037L88.797 39.2269L87.6603 43.1556L85.4737 42.6132L86.6125 38.6777L83.8812 38L82.7424 41.9355L77.7366 40.6934L76.9401 43.4467L80.4248 44.3114L76.7813 56.9036L73.2965 56.0389L72.5 58.7922L77.5058 60.0343L76.3281 64.1046L79.0594 64.7823L80.2371 60.712L82.4238 61.2544L81.2466 65.3232L83.9737 66L85.1509 61.9311L87.4048 62.4906C90.5105 63.2613 93.7045 61.5538 94.5368 58.6773C95.3691 55.8008 93.5189 52.8615 90.4132 52.0908ZM84.919 45.3329L86.8885 45.8217L88.195 46.146C88.725 46.2775 89.1582 46.5355 89.4989 46.9021C90.0967 47.5015 90.3522 48.373 90.1083 49.2148C89.8649 50.0566 89.173 50.6935 88.3317 50.9354C87.8391 51.0951 87.3249 51.118 86.7944 50.9866L85.4879 50.6623L83.5184 50.1735L84.919 45.3329ZM86.1046 58.6345C86.0426 58.6379 86.0047 58.6286 85.9479 58.6145L83.3722 57.9752L81.4027 57.4864L82.8034 52.6458L84.7729 53.1347L87.3486 53.774C87.4053 53.7881 87.4432 53.7973 87.4953 53.829C88.8433 54.2199 89.6325 55.5623 89.2618 56.8428C88.8912 58.1233 87.4832 58.9203 86.1046 58.6345Z"
      fill="#FFB029"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="132" y="39.0909">Connected BTC Hashrate</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="132" y="71.74">{{ stats.hashrateShare }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">Share</tspan>
    </text>

    <rect x="441.333" width="397.333" height="104" rx="16" fill="#111111" />
    <rect x="457.333" y="16" width="72" height="72" rx="12" fill="#1F1F1F" />
    <path
      d="M483.7 57.3724L474.792 48.4562L484.575 38.6737L499.31 35.0862L502.643 38.4199L483.7 57.3724ZM479.237 48.4562L483.7 52.9187L497.962 38.6562L486.176 41.5174L479.246 48.4474L479.237 48.4562Z"
      fill="#FF9900"
    />
    <path
      d="M505.688 69.3949L486.753 50.4687L492.948 44.2737L511.875 63.1999L505.68 69.3949H505.688ZM491.216 50.4687L505.688 64.9412L507.43 63.1999L492.948 48.7274L491.207 50.4687H491.216Z"
      fill="#FF9900"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="541.333" y="39.0909">BTC Staked</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="541.333" y="71.74">{{ displayTokenValue(stats.btcTotalStaking) }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">BTC</tspan>
    </text>

    <rect x="850.667" width="397.333" height="104" rx="16" fill="#111111" />
    <rect x="866.667" y="16" width="72" height="72" rx="12" fill="#1F1F1F" />
    <path
      d="M893.033 57.3724L884.125 48.4562L893.908 38.6737L908.643 35.0862L911.976 38.4199L893.033 57.3724ZM888.57 48.4562L893.033 52.9187L907.295 38.6562L895.509 41.5174L888.579 48.4474L888.57 48.4562Z"
      fill="#FF9900"
    />
    <path
      d="M915.021 69.3949L896.086 50.4687L902.281 44.2737L921.208 63.1999L915.013 69.3949H915.021ZM900.549 50.4687L915.021 64.9412L916.763 63.1999L902.281 48.7274L900.54 50.4687H900.549Z"
      fill="#FF9900"
    />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="950.667" y="39.0909">XSAT Staked</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="24"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="950.667" y="71.74">{{ displayTokenValue(stats.xsatTotalStaking) }}</tspan>
      <tspan fill="#BFBFBF" font-size="20">XSAT</tspan>
    </text>

    <rect x="32" y="116" width="392" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="56" y="148.091">Total Synced</tspan>
    </text>
    <text
      fill="#F5F5F5"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="208" y="150.7">{{ stats.parsedHeight || '-' }} BTC Blocks</tspan>
    </text>
    <rect x="436" y="116" width="262.667" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="460" y="148.091">BTC Validators</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="649.667" y="150.7">{{ stats.btcTotalValidators }}</tspan>
    </text>
    <rect x="710.667" y="116" width="262.667" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="734.667" y="148.091">XSAT Validators</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="920.333" y="150.7">{{ stats.xsatTotalValidators }}</tspan>
    </text>
    <rect x="985.333" y="116" width="262.667" height="54" rx="16" fill="#111111" />
    <text
      fill="#999999"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="14"
      font-weight="600"
      letter-spacing="0.01em"
    >
      <tspan x="1009.33" y="148.091">Total Synchronizers</tspan>
    </text>
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="20"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="1188" y="150.7">{{ displayTokenValue(stats.totalSynchronizers) }}</tspan>
    </text>
  </svg>
</template>
<script setup>
import { useTotalCount } from '@/page/Protocolintro/hook/useTotalCount.js'
const { stats, displayTokenValue } = useTotalCount()
</script>
